module.exports = __webpack_public_path__ + "img/invision_branding_product-logos_DSM_black.2694e487.svg";